import { Guest } from '@/app/system/guest/Guest';

export class PromisePatron implements Guest<T> {
  private resolve: (value: T) => void;
  private reject: (reason: Error) => void;

  private thePromise = new Promise((
    resolve: (value: T) => void,
    reject: (reason: Error) => void,
  ) => {
    this.resolve = resolve;
    this.reject = reject;
  });

  public receive(value: T): this {
    this.resolve(value);
    return this;
  }

  public promise() {
    return this.thePromise;
  }

  public doReject(reason: Error) {
    this.reject(reason);
  }

  public introduction() {
    return 'patron' as const;
  }
}
